import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { CheckListMultiLineModule } from '@vfde-fe/ngx-lib/components/check-list-multiline';
import { CheckboxGroupModule } from '@vfde-fe/ngx-lib/components/checkbox-group';
import { CheckboxItemModule } from '@vfde-fe/ngx-lib/components/checkbox-item';
import { DropDownStandAloneModule } from '@vfde-fe/ngx-lib/components/dropdown-stand-alone';
import { DropdownModule } from '@vfde-fe/ngx-lib/components/dropdown';
import { HtmlTemplateModule } from '@vfde-fe/ngx-lib/components/html-template';
import { RadioTilesModule } from '@vfde-fe/ngx-lib/components/radio-tiles';
import { InlineTooltipModule } from '@vfde-fe/ngx-lib/components/inline-tooltip';
import { OverlayNotificationModule } from '@vfde-fe/ngx-lib/components/overlay-notification';
import { PromoNotificationModule } from '@vfde-fe/ngx-lib/components/promo-notification';
import { AccordionModule } from '@vfde-fe/ngx-lib/components/accordion';
import { AccordionGroupModule } from '@vfde-fe/ngx-lib/components/accordion-group';
import { TextModule } from '@vfde-fe/ngx-lib/components/new-text';
import { SpinnerModule } from '@vfde-fe/ngx-lib/components/spinner';
import { NbaSliderModule } from '@vfde-fe/ngx-lib/components/nba-slider';
import { StepperModule } from '@vfde-fe/ngx-lib/components/stepper-module';
import { SwitcherModule } from '@vfde-fe/ngx-lib/components/switcher';
import { OlTopupCardModule } from '@vfde-fe/ngx-lib/components/ol-topup-card';
import { BewModule } from '@vfde-fe/ngx-lib/components/bew-permissions';
import { OlRadioModule } from '@vfde-fe/ngx-lib/components/ol-radio';
import { LinkOutsModule } from '@vfde-fe/ngx-lib/components/link-outs';
import { TransactionHeaderModule } from '@vfde-fe/ngx-lib/components/transaction-header';
import { ConfirmationWarningMessageModule } from '@vfde-fe/ngx-lib/components/confirmation-warning-message';
import { InfoIconModule } from '@vfde-fe/ngx-lib/components/info-icon';
import { NotificationModule } from '@vfde-fe/ngx-lib/components/new-notification';
import { OfferCardWrapperModule } from '@vfde-fe/ngx-lib/components/offer-card-wrapper';
import { AnchorLinkModule } from '@vfde-fe/ngx-lib/components/new-anchor-link';
import { GeneralCardModule } from '@vfde-fe/ngx-lib/components/generalCard';
import { LargeCardModule } from '@vfde-fe/ngx-lib/components/large-card';
import { SideLinksMenuModule } from '@vfde-fe/ngx-lib/components/side-links-menu';
import { SeamlessInfoModule } from '@vfde-fe/ngx-lib/components/new-seamless-info';
import { NavigationModule } from '@vfde-fe/ngx-lib/components/navigation';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { OfferCardItemModule } from '@vfde-fe/ngx-lib/components/offer-card-items';
import { OlTopupGroupModule } from '@vfde-fe/ngx-lib/components/ol-topup-group';
import { OlBasketModule } from '@vfde-fe/ngx-lib/components/ol-basket';
import { ExtendedFooterComponentModule } from '@vfde-fe/ngx-lib/directives/new-extended-footer';

/** modules  */
@NgModule({
    imports: [
        CommonModule,
        NgxSmartModalModule.forChild(),
        TranslateModule.forChild(),
        RouterModule,
        NgxPaginationModule,
        FormsModule,
        ReactiveFormsModule,
        InlineTooltipModule,
        OverlayNotificationModule,
        PromoNotificationModule,
        CheckListMultiLineModule,
        CheckboxItemModule,
        AccordionModule,
        AccordionGroupModule,
        DropdownModule,
        TextModule,
        SpinnerModule,
        NbaSliderModule,
        StepperModule,
        SwitcherModule,
        OlTopupCardModule,
        CheckboxGroupModule,
        BewModule,
        DropDownStandAloneModule,
        HtmlTemplateModule,
        OlRadioModule,
        LinkOutsModule,
        TransactionHeaderModule,
        ConfirmationWarningMessageModule,
        InfoIconModule,
        NotificationModule,
        OfferCardWrapperModule,
        AnchorLinkModule,
        GeneralCardModule,
        LargeCardModule,
        SideLinksMenuModule,
        SeamlessInfoModule,
        NavigationModule,
        OfferCardItemModule,
        RadioTilesModule,
        OlTopupGroupModule,
        OlBasketModule,
        ExtendedFooterComponentModule,
    ],
    exports: [
        InlineTooltipModule,
        OverlayNotificationModule,
        PromoNotificationModule,
        CheckListMultiLineModule,
        CheckboxItemModule,
        AccordionModule,
        AccordionGroupModule,
        DropdownModule,
        TextModule,
        SpinnerModule,
        NbaSliderModule,
        StepperModule,
        SwitcherModule,
        OlTopupCardModule,
        CheckboxGroupModule,
        BewModule,
        DropDownStandAloneModule,
        HtmlTemplateModule,
        OlRadioModule,
        LinkOutsModule,
        TransactionHeaderModule,
        InfoIconModule,
        NotificationModule,
        AnchorLinkModule,
        GeneralCardModule,
        LargeCardModule,
        SeamlessInfoModule,
        NavigationModule,
        OfferCardItemModule,
        RadioTilesModule,
        OlTopupGroupModule,
        OlBasketModule,
        ExtendedFooterComponentModule,
    ],

})
export class CoreUiModule { }
